import {LogLevel} from './log-level.enum';
import {isDefined} from "../../libs/utils/epic.utils";

export class LogMessage {

  private readonly level: LogLevel;
  private readonly message: string;
  private stack: string | undefined;
  private readonly clazz: string | undefined;
  private readonly type: string | undefined;
  private readonly code: string | number | undefined;

  constructor(level: LogLevel, message: string, params?: any[], stack?: string, clazz?: string, type?: string, code?: string | number) {
    this.level = level;
    this.stack = stack;
    this.clazz = clazz;
    this.type = type;
    this.code = code;

    let msg: string = message;
    if (isDefined(params)) {
      params.forEach((p: any) => {
        let messageParamValue: any = p;

        if (p instanceof Map) {
          messageParamValue = '';
          (p as Map<any, any>).forEach((k, v) => {
            messageParamValue = messageParamValue + k + ': ' + v + '; ';
          });
        } else if (p instanceof Error) {
          messageParamValue = p.message;
          this.stack = p.stack;
        } else if (typeof p === 'object') {
          messageParamValue = JSON.stringify(p);
        }

        if (typeof messageParamValue === 'string') {
          messageParamValue = messageParamValue.replaceAll('{}', '{ }');
        }

        if (msg.indexOf('{}') >= 0) {
          msg = msg.replace('{}', messageParamValue);
        } else {
          throw new Error('Logging: placeholder and params count mismatch. Message: ' + message);
        }
      });
    }

    if (msg.indexOf('{}') >= 0) {
      throw new Error('Logging: placeholder and params count mismatch. Message: ' + message);
    }
    this.message = msg;
  }

  public getLevel(): LogLevel {
    return this.level;
  }

  public buildMessage(): string {
    return this.message;
  }

  public buildMessageWithLevel(): string {
    return '[' + LogLevel[this.getLevel()] + '] ' + this.buildMessage();
  }

  public getStack(): string | undefined {
    return this.stack;
  }

  public getClazz(): string | undefined {
    return this.clazz;
  }

  public getType(): string | undefined {
    return this.type;
  }

  public getCode(): string | number | undefined {
    return this.code;
  }
}
